import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Box, Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import AddQrCode from './components/AddQrCode';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import AddQrCodeStyled from './AddQrCodeStyles';
import StoreModal from '@/components/StoreModalML/StoreModal';

export default () => {
  const submitRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { id, isCopy, queryType } = query;
  const { handleSubmit, control, setValue, watch, getValues, errors } =
    useForm();
  const { qrParamsFormData } = useSelector((state) => state.miniQrCode);
  const [isSubmit, setIsSubmit] = useState(false);
  //外部导入文件list
  const [fileList, setFileList] = useState([]);
  const [saveOpen, setSaveOpen] = useState({
    tips: '',
    status: false,
    title: '',
  });
  const saveRef = useRef();
  const [storesChooseDataId, setStoresChooseDataId] = useState([]); //可用选中的门店Id
  const [storesChooseItemData, setStoresChooseItemData] = useState([]); //可用存储所有选中数据列
  const [storesChooseItemShowData, setStoresChooseItemShowData] = useState([]); //可用选中的门店点确定后的值列
  const [storesChooseItemShowIdData, setStoresChooseItemShowIdData] = useState(
    [],
  ); //可用选中的门店点确定后的值Id
  const [dialogStatus, setDialogStatus] = useState(false); //选中可用门店model的状态
  const {
    control: storeControl,
    handleSubmit: handleSubmitStore,
    setValue: setValueStore,
    getValues: getValuesStore,
    reset: resetStore,
    watch: watchStore,
  } = useForm();
  const {
    storesList,
    storeName,
    storeCode,
    storeStatus,
    storeType,
    storesPageNum,
    storesPageSize,
  } = useSelector((state) => state.couponsSetting);
  // 获取门店列表
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getStores',
      payload: {
        value: {
          name: storeName,
          code: storeCode,
          status: storeStatus,
          type: storeType,
          pageNum: storesPageNum,
          pageSize: storesPageSize,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    storeName,
    storesPageNum,
    storesPageSize,
    storeCode,
    storeStatus,
    storeType,
  ]);
  //提交成功
  const handleSubmitSuccess = (data) => {
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    let qrParamsStatus = 0;
    let newQrParamsFormDataDeleteId = null;
    if (data.createType === '1') {
      const newQrParamsFormData = qrParamsFormData.filter(
        (item) => item.name || item.value,
      );
      newQrParamsFormData.forEach((item) => {
        if (item.name && !item.value) {
          qrParamsStatus = 1; //有id,没有内容
          return;
        } else if (!item.name && item.value) {
          qrParamsStatus = 2; //没有id,有内容
          return;
        }
      });
      if (qrParamsStatus === 1) {
        setIsSubmit(false);
        return window.message.toast({
          type: 'error',
          message: '参数内容不得为空',
          title: '错误',
        });
      } else if (qrParamsStatus === 2) {
        setIsSubmit(false);
        return window.message.toast({
          type: 'error',
          message: '参数ID不得为空',
          title: '错误',
        });
      }
      const newListLength = new Set(
        newQrParamsFormData.map((item) => item.name),
      ).size;
      if (newQrParamsFormData?.length > newListLength) {
        setIsSubmit(false);
        return window.message.toast({
          type: 'error',
          message: '参数ID不可重复',
          title: '错误',
        });
      }
      newQrParamsFormDataDeleteId =
        newQrParamsFormData?.length > 0
          ? newQrParamsFormData.map((item) => ({
              name: item.name,
              value: item.value,
            }))
          : null;
    }
    const values = {
      data: {
        ...data,
        params: newQrParamsFormDataDeleteId,
        storeInfoList: data.stores ? JSON.parse(data.stores) : null,
        id,
        isCopy,
        importUrl: fileList?.[0]?.url || null,
        importFileName: fileList?.[0]?.fileName || null,
      },
    };
    window.NE_DAWN.trigger(saveRef.current, {
      event: '_ec', // 事件名
      params: { ...values }, // 事件公参
    });

    dispatch({
      type: 'miniQrCode/addQrCode',
      payload: {
        values,
      },
      callback: (code) => {
        if (code === 0) {
          window.message.toast({
            type: 'success',
            message: !id ? '新增成功' : '编辑成功',
            title: '成功',
          });
          history.goBack();
        } else {
          setIsSubmit(false);
        }
      },
    });
  };
  //提交失败
  const handleSubmitFail = (error) => {
    setIsSubmit(false);
    console.log('error', error);
  };

  useEffect(() => {
    if (!id) {
      return false;
    }
    dispatch({
      type: 'miniQrCode/getQueryQrCode',
      payload: {
        values: {
          id,
        },
      },
      callback: () => {},
    });
  }, [id, dispatch]);

  //获取公众号列表
  const fetchAppIdList = useCallback(() => {
    dispatch({
      type: 'addAutoReplyRule/getMiniProgramAccountList',
      payload: {
        values: {},
      },
      callback: (res) => {
        //初始默认选中第一个
        const data = res?.data || [];
        data.length > 0 &&
          queryType === 'add' &&
          setValue('appId', data[0].appId);
      },
    });
  }, [dispatch, setValue]);
  useEffect(() => {
    fetchAppIdList();
  }, [fetchAppIdList]);

  const handleSubmitData = () => {
    // setOpenError(true);
    setSaveOpen({
      status: true,
      tips: '确认保存当前所创建的内容？',
      title: '保存',
    });
  };

  //新建标签自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseDialog}
          color="secondary"
        >
          取消
        </Button>
        <Button
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={onSaveLabelDialog}
        >
          确定
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };
  const onCloseDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
  };

  const onSaveLabelDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
    console.log('saveOpen', saveOpen);
    if (saveOpen.title === '保存') {
      submitRef.current.click();
      return;
    }
    history.goBack();
  };
  const handleClickOpen = () => {
    if (queryType === 'detail') {
      history.goBack();
      return;
    }
    setSaveOpen({
      status: true,
      tips: '退出后将不保存设置内容，确定要退出吗？',
      title: '退出',
    });
  };

  const columns = [
    {
      type: 'checkbox',
      width: '100',
      onChange: (a) => {
        const pageDataIds = storesList.map((item) => item.storeNo); //当前分页的id数组
        const prevStoresChooseItemData = storesChooseItemData?.filter(
          (item) => {
            //过滤掉当前页的选中列
            return pageDataIds.indexOf(item.storeNo) === -1;
          },
        );

        let chooseDatas = storesList.filter((fItem) => {
          //当前选中的数据过滤出当前页的数据
          return a.includes(fItem.storeNo);
        });

        const newListData = [...prevStoresChooseItemData, ...chooseDatas]?.map(
          (item) => ({ ...item, storeName: item.name }),
        );
        //将选中的数据a替换老数据
        const newIdsData = newListData.map((item) => item.storeNo);
        setStoresChooseDataId(newIdsData);
        setStoresChooseItemData(newListData);
      },
    },
    {
      title: '门店Code',
      id: 'storeNo',
      align: 'center',
      width: 150,
    },
    {
      title: '门店名称',
      id: 'name',
      align: 'center',
      width: 200,
    },
    {
      title: '门店状态',
      id: 'statusCn',
      align: 'center',
      width: 100,
    },
    {
      title: '门店类型',
      id: 'storeType',
      align: 'center',
      width: 100,
    },
  ];
  const changePageStore = (data) => {
    dispatch({
      type: 'couponsSetting/setStoresPage',
      payload: {
        value: {
          pageNum: data.pageNum,
          pageSize: data.pageSize,
        },
      },
    });
  };
  const onCloseDialogStore = (data) => {
    console.log({ data, storesChooseItemData, storesChooseDataId });
    if (data) {
      setStoresChooseItemShowData(storesChooseItemData);
      setStoresChooseItemShowIdData(storesChooseDataId);
    } else {
      setStoresChooseItemData(storesChooseItemShowData);
      setStoresChooseDataId(storesChooseItemShowIdData);
    }

    setDialogStatus(false);
  };

  const onSubmitSuccessStore = (data) => {
    dispatch({
      type: 'couponsSetting/searchStores',
      payload: {
        value: { ...data, pageNum: 1, pageSize: storesPageSize },
      },
    });
  };

  return (
    <AddQrCodeStyled queryType={queryType}>
      <Box
        data-log={JSON.stringify({
          oid: 'page_miniprogram_qrcode_management_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        height="100%"
      >
        <Box
          borderRadius="4px"
          bgcolor="background.paper"
          pt={7}
          pr={7}
          pb={4}
          pl={7}
        >
          <form onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFail)}>
            <AddQrCode
              control={control}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              errors={errors}
              setFileList={setFileList}
              fileList={fileList}
              storesChooseDataId={storesChooseDataId}
              storesChooseItemData={storesChooseItemData}
              storesChooseItemShowData={storesChooseItemShowData}
              storesChooseItemShowIdData={storesChooseItemShowIdData}
              setStoresChooseDataId={setStoresChooseDataId}
              setStoresChooseItemData={setStoresChooseItemData}
              setStoresChooseItemShowData={setStoresChooseItemShowData}
              setStoresChooseItemShowIdData={setStoresChooseItemShowIdData}
              setDialogStatus={setDialogStatus}
            />
            <Box display="flex" gap="0 4px" pt={6}>
              {queryType !== 'detail' && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_miniprogram_qrcode_management_edit_finish',
                    events: ['_ev'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  ref={saveRef}
                  variant="contained"
                  className="coupons-setting-button"
                  onClick={handleSubmitData}
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  完成
                </Button>
              )}
              <Button
                variant="contained"
                className="coupons-setting-button"
                color="secondary"
                onClick={handleClickOpen}
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
              >
                退出
              </Button>
              <Button
                sx={{ display: 'none' }}
                type="submit"
                ref={submitRef}
              ></Button>
            </Box>
          </form>
        </Box>
      </Box>
      <StoreModal
        columnKey="storeNo"
        dialogStatus={dialogStatus}
        title="选择门店"
        chooseIds={storesChooseItemShowIdData}
        columns={columns}
        control={storeControl}
        getValues={getValuesStore}
        setValue={setValueStore}
        watch={watchStore}
        reset={resetStore}
        changePage={changePageStore}
        onCloseDialog={onCloseDialogStore}
        handleSubmit={handleSubmitStore}
        onSubmitSuccess={onSubmitSuccessStore}
      />
      <DialogDataML
        open={saveOpen.status}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span
              style={{ fontSize: '18px', fontWeight: 600, color: '#212121' }}
            >
              {saveOpen.title}
            </span>
          </Box>
        }
        content={<Box sx={{ width: '336px' }}>{saveOpen.tips}</Box>}
        handleClose={onCloseDialog}
        button={initButton()}
      />
    </AddQrCodeStyled>
  );
};
